import React from 'react';
import Status from '../../components/Status';
import StatusMessage from '../StatusMessage';

const NotFound = () => {

    return (
        <Status code={404}>
            <StatusMessage />
        </Status>
    );

};

export default NotFound;
